import * as Request from '../Request';
const CheckStandard = {
  /**
   * 目录增删改查
   * @param data
   * @returns {*}
   */
  getTreeData: (data) => {
    return Request.get('/CheckStandard/tree', data)
  },
  addTreeItem: (data) => {
    return Request.post('/CheckStandard/save', data)
  },
  updateTreeItem: (data) => {
    return Request.post('/CheckStandard/update', data)
  },
  delTreeItem: (data) => {
    return Request.del('/CheckStandard/delete', data)
  },
  /**
   * 检查标准项增删改查
   * @param data
   * @returns {*}
   */
  getTableData: (data) => {
    return Request.post('/CheckStandard/item/list', data)
  },
  addCheckItem: (data) => {
    return Request.post('/CheckStandard/item/save', data)
  },
  updateCheckItem: (data) => {
    return Request.post('/CheckStandard/item/update', data)
  },
  delCheckItem: (data) => {
    return Request.del('/CheckStandard/item/delete', data)
  },
  /**
   * 检查标准项下隐患的增删改查
   */
  getyhList: (data) => {
    return Request.post('/CheckStandard/yh/list', data)
  },
  addyh: (data) => {
    return Request.post('/CheckStandard/yh/save', data)
  },
  updateyh: (data) => {
    return Request.post('/CheckStandard/yh/update', data)
  },
  delyh: (data) => {
    return Request.del('/CheckStandard/yh/delete', data)
  }

}
export default CheckStandard
